module.exports = __webpack_public_path__ + "img/active-2.a665e78e.png";